import { render, staticRenderFns } from "./FooterNav.vue?vue&type=template&id=1811b83a&scoped=true"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"
import style0 from "./FooterNav.vue?vue&type=style&index=0&id=1811b83a&prod&lang=scss&scoped=true"
import style1 from "./FooterNav.vue?vue&type=style&index=1&id=1811b83a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811b83a",
  null
  
)

export default component.exports